exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".study-list__action-buttons {\n  display: grid;\n  width: 100%;\n  grid-template-columns: 20% 20% auto;\n  grid-column-gap: 0.5rem;\n  grid-row-gap: 0.5rem; }\n  .study-list__action-buttons__inference {\n    grid-column: 3; }\n", ""]);

